import { NodeType } from '@/api/nodes/mutations/directory/create-directory-mutation'
import {
    INodeAction,
    IUseActionReturnType,
    NodeActionScope,
} from '@/features/drive/functionalities/actions/node/core/shared/utils/node-action-helpers'
import { useDirectorySelectionContext } from '@/features/drive/functionalities/selection/directory-selection-context'
import { useDownloadFiles } from '@/features/files/download-files'
import { useFileContext } from '@/features/files/file-context'
import { Download } from 'lucide-react'
import { useMemo } from 'react'

export const useNodeDownloadAction = (): IUseActionReturnType => {
    const { file } = useFileContext() || {}

    const {
        state: { selectedCount },
        download: { downloadSelected },
    } = useDirectorySelectionContext()

    const downloadFiles = useDownloadFiles()

    const action: INodeAction = useMemo(() => {
        return {
            icon: Download,
            label: 'Download',
            call: () => {
                if (selectedCount > 0) {
                    // Bulk download is tracked in directory-selection-context
                    downloadSelected?.()
                    return
                }

                if (!file) return

                downloadFiles({ files: [file] })
            },
            applicableForScopes: [NodeActionScope.SELECTED_SINGLE, NodeActionScope.PREVIEW],
            applicableForTypes: [NodeType.FILE, NodeType.DIRECTORY],
        }
    }, [downloadSelected, file, selectedCount, downloadFiles])

    return { action, nodes: <></> }
}
